// src/utils/downloadFilename.js
export function extractFilenameFromContentDisposition(cdHeader) {
  if (!cdHeader || typeof cdHeader !== 'string') return null;

  // Try RFC 5987: filename*=UTF-8''....
  let match = cdHeader.match(/filename\*\s*=\s*([^;]+)/i);
  if (match && match[1]) {
    let v = match[1].trim();
    // Strip optional charset'' prefix like UTF-8''
    const parts = v.split("''");
    if (parts.length === 2) {
      try {
        v = decodeURIComponent(parts[1].replace(/(^"|"$)/g, ''));
        if (v) return v;
      } catch (_) {
        // fall through to regular filename=
      }
    } else {
      // Some servers send filename*=<value> without charset.
      try {
        v = decodeURIComponent(v.replace(/(^"|"$)/g, ''));
        if (v) return v;
      } catch (_) {}
    }
  }

  // Fallback: filename="..." OR filename=...
  match = cdHeader.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
  if (match) {
    return (match[1] || match[2]).trim();
  }
  return null;
}

export function sanitizeFilename(raw, { defaultExt = 'pdf' } = {}) {
  if (!raw) return `download.${defaultExt}`;
  // Replace illegal characters on Windows and trim spaces
  const illegal = /[\/\\:\*\?"<>\|\u0000-\u001F]/g; // includes control chars
  let name = raw.replace(illegal, ' ').replace(/\s{2,}/g, ' ').trim();

  // Avoid reserved names like "." or ".."
  if (!name || /^\.+$/.test(name)) name = `download.${defaultExt}`;

  // If there’s no extension, append a default
  if (!/\.[A-Za-z0-9]{1,8}$/.test(name)) {
    name = `${name}.${defaultExt}`;
  }
  return name;
}
